import PropTypes from 'prop-types'
import React from 'react'
import { Button } from '..'
import './ModalStyle.scss'

const Modal = ({ title, description, cancelTxt, onCancel, okTxt, onOk, children }) => (
  <div className="bdn-modal">
    <p className="modal-title">{title}</p>
    {description && <p>{description}</p>}
    {children}
    <div className="modal-actions">
      <Button
        appearance="secondary"
        type="outline"
        text={cancelTxt}
        onClick={() => onCancel()}
        width="30%"
      />
      <Button text={okTxt} onClick={() => onOk()} width="60%" />
    </div>
  </div>
)

Modal.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  cancelTxt: PropTypes.string.isRequired,
  okTxt: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onOk: PropTypes.func.isRequired,
  children: PropTypes.node,
}

Modal.defaultProps = {
  description: '',
  children: null,
}

export default Modal
